module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"bonusSectionTitle":"Bonus","bonusSectionSubtitle":"Se hva annet du har lært","collapsedButtonLabel":"Se nå","shareButton":"Share"},"en":{"bonusSectionTitle":"Bonus","bonusSectionSubtitle":"Se hva annet du har lært","collapsedButtonLabel":"Se nå","shareButton":"Share"}}')
  delete Component.options._Ctor
}
